import React, { useState } from 'react';
import axios from 'axios';
import './CahierDesCharges.css';

function CahierDesChargesPublic() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [accessCode, setAccessCode] = useState('');
  const [codeError, setCodeError] = useState(false);

  const ACCESS_CODE = '2626';

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    if (accessCode.trim().toUpperCase() === ACCESS_CODE) {
      setIsUnlocked(true);
      setCodeError(false);
    } else {
      setCodeError(true);
    }
  };

  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [formSent, setFormSent] = useState(false);

  const currentDate = new Date().toLocaleDateString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  // SVG Icons
  const icons = {
    target: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
      </svg>
    ),
    user: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
    ),
    phone: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
    ),
    car: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H5.24a2 2 0 0 0-1.8 1.1l-.8 1.63A6 6 0 0 0 2 12.42V16h2"/><circle cx="6.5" cy="16.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/>
      </svg>
    ),
    check: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    ),
    tool: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
      </svg>
    ),
    settings: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
    ),
    clock: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
    clipboard: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
      </svg>
    ),
    mapPin: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
      </svg>
    ),
    info: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
    ),
    handshake: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"/>
      </svg>
    ),
    rocket: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
      </svg>
    ),
    chart: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
    award: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
      </svg>
    ),
    gift: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
      </svg>
    ),
    link: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
      </svg>
    ),
    printer: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/>
      </svg>
    ),
    whatsapp: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    send: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
      </svg>
    )
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      await axios.post('/api/candidatures', formData);
      setFormSent(true);
      setFormData({ nom: '', email: '', telephone: '', message: '' });
    } catch (err) {
      console.error('Erreur envoi candidature:', err);
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setSending(false);
    }
  };

  if (!isUnlocked) {
    return (
      <div className="cahier-des-charges-public">
        <div className="cahier-lock-screen">
          <div className="lock-card">
            <div className="lock-icon-container">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lock-svg">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <div className="lock-logo">E-Shop Pro</div>
            <h2 className="lock-title">Document Confidentiel</h2>
            <p className="lock-subtitle">Veuillez entrer le code d'acces pour consulter le Cahier des Charges</p>
            <form onSubmit={handleCodeSubmit} className="lock-form">
              <input
                type="text"
                value={accessCode}
                onChange={(e) => { setAccessCode(e.target.value); setCodeError(false); }}
                placeholder="Code d'acces"
                className={`lock-input ${codeError ? 'lock-input-error' : ''}`}
                autoFocus
                autoComplete="off"
              />
              {codeError && <p className="lock-error-msg">Code incorrect. Veuillez reessayer.</p>}
              <button type="submit" className="lock-btn">Acceder au document</button>
            </form>
            <p className="lock-hint">Contactez votre responsable si vous n'avez pas le code.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cahier-des-charges-public">
      <div className="cahier-des-charges">
        <div className="cahier-header">
          <div className="header-badge">Document Officiel</div>
          <div className="cahier-title-section">
            <div className="logo-container">
              <div className="logo-icon">
                <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" rx="10" fill="rgba(255,255,255,0.2)"/>
                  <path d="M12 14h16M12 20h12M12 26h8" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
                  <circle cx="28" cy="26" r="4" fill="#fbbf24"/>
                </svg>
              </div>
              <span className="logo-text">E-Shop Pro</span>
            </div>
            <h1>Cahier des Charges</h1>
            <p className="cahier-subtitle">Prise de rendez-vous physiques sur site</p>
          </div>
          <p className="cahier-date">Mis à jour le {currentDate}</p>
        </div>

        {/* Hero section with devices illustration */}
        <div className="hero-illustration">
          <div className="hero-content">
            <div className="hero-icon-svg">{icons.rocket}</div>
            <h2>Solution Digitale Complète</h2>
            <p>Site web, application mobile, outils connectés</p>
          </div>
          <div className="hero-devices">
            <div className="mini-laptop">
              <div className="mini-screen"></div>
              <div className="mini-base"></div>
            </div>
            <div className="mini-phone">
              <div className="mini-phone-screen"></div>
            </div>
          </div>
        </div>

        <div className="cahier-content">
          {/* Objectif */}
          <section className="cahier-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.target}</span>
              <h2>Objectif</h2>
            </div>
            <div className="section-content">
              <p>
                Obtenir des <strong>rendez-vous physiques sur le lieu de travail du client</strong>, avec des gérants de PME/PMI,
                afin de leur proposer une <strong>solution digitale complète offerte</strong> (site, application, outils connectés, etc.)
                en échange de la possibilité pour E-Shop Pro d'utiliser leur projet comme <strong>modèle vitrine</strong> pour de futures
                présentations commerciales dans leur secteur.
              </p>
            </div>
          </section>

          {/* Profil du contact */}
          <section className="cahier-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.user}</span>
              <h2>Profil du contact à cibler</h2>
            </div>
            <div className="section-content">
              <ul className="criteria-list">
                <li>
                  <span className="check-icon-svg">{icons.check}</span>
                  <span className="criteria-text">Le contact doit être le <strong>gérant, co-gérant ou associé décisionnaire</strong> de l'entreprise.</span>
                </li>
                <li>
                  <span className="check-icon-svg">{icons.check}</span>
                  <span className="criteria-text">L'entreprise doit être une <strong>PME, PMI ou TPE active</strong>, disposant de locaux ou d'un point d'activité visible.</span>
                </li>
                <li>
                  <span className="check-icon-svg">{icons.check}</span>
                  <span className="criteria-text">Le gérant doit être <strong>présent sur place</strong> le jour du rendez-vous.</span>
                </li>
                <li>
                  <span className="check-icon-svg">{icons.check}</span>
                  <span className="criteria-text">Le contact doit avoir un <strong>réel intérêt pour le digital</strong> et vouloir développer ou moderniser son image en ligne.</span>
                </li>
              </ul>
            </div>
          </section>

          {/* Qualification */}
          <section className="cahier-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.phone}</span>
              <h2>Qualification avant validation du rendez-vous</h2>
            </div>
            <div className="section-content">
              <p className="section-intro">Le téléprospecteur doit confirmer <strong>tous les points suivants</strong> avant de planifier la visite :</p>

              <div className="qualification-block">
                <h3><span className="block-icon">{icons.clipboard}</span> Identité du contact</h3>
                <ul className="checklist">
                  <li><span className="bullet"></span><span className="checklist-text">Nom complet du gérant</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Nom de la société</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Fonction exacte</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Téléphone direct</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Adresse complète du lieu de travail</span></li>
                </ul>
              </div>

              <div className="qualification-block">
                <h3><span className="block-icon">{icons.mapPin}</span> Présence et disponibilité</h3>
                <ul className="checklist">
                  <li><span className="bullet"></span><span className="checklist-text">Le gérant ou un associé décisionnaire sera bien présent lors de la visite.</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Jour et heure convenus selon la tournée commerciale d'E-Shop Pro.</span></li>
                </ul>
              </div>

              <div className="qualification-block">
                <h3><span className="block-icon">{icons.info}</span> Information sur l'offre</h3>
                <ul className="checklist">
                  <li><span className="bullet"></span><span className="checklist-text">L'entreprise bénéficie d'une <strong>offre vitrine</strong>, c'est-à-dire que la création et le développement sont offerts.</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Elle sert ensuite de <strong>modèle de démonstration</strong> pour le même type de solutions dans son secteur.</span></li>
                  <li>
                    <span className="bullet"></span>
                    <span className="checklist-text">
                      Le gérant est informé qu'il peut rester quelques <strong>frais techniques</strong>, comme :
                      <ul className="sub-checklist">
                        <li>L'achat du nom de domaine</li>
                        <li>L'hébergement du site ou de l'application</li>
                        <li>Une maintenance ou mise à jour selon les modules déployés</li>
                      </ul>
                    </span>
                  </li>
                </ul>
              </div>

              <div className="qualification-block">
                <h3><span className="block-icon">{icons.handshake}</span> Engagement attendu</h3>
                <ul className="checklist">
                  <li><span className="bullet"></span><span className="checklist-text">Le gérant est d'accord pour recevoir l'équipe E-Shop Pro sur son lieu de travail.</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Il comprend que la visite vise à évaluer son activité pour voir si elle peut devenir entreprise vitrine.</span></li>
                  <li><span className="bullet"></span><span className="checklist-text">Il s'engage à donner une <strong>réponse claire</strong> à la fin de l'entretien (oui / non à la proposition).</span></li>
                </ul>
              </div>
            </div>
          </section>

          {/* Déroulement du RDV */}
          <section className="cahier-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.car}</span>
              <h2>Déroulement du rendez-vous</h2>
            </div>
            <div className="section-content">
              <ul className="process-list">
                <li>
                  <span className="step-number">1</span>
                  <div className="step-content">
                    Le rendez-vous se déroule <strong>dans les locaux du client</strong> (magasin, bureau, atelier, etc.).
                  </div>
                </li>
                <li>
                  <span className="step-number">2</span>
                  <div className="step-content">
                    L'équipe E-Shop Pro présente :
                    <ul className="sub-list">
                      <li>L'entreprise</li>
                      <li>Les projets déjà réalisés</li>
                      <li>L'offre vitrine et ses avantages</li>
                    </ul>
                  </div>
                </li>
                <li>
                  <span className="step-number">3</span>
                  <div className="step-content">
                    Le gérant peut montrer son activité et ses besoins pour adapter la solution.
                  </div>
                </li>
                <li>
                  <span className="step-number">4</span>
                  <div className="step-content duration-badge">
                    <span className="duration-icon-svg">{icons.clock}</span>
                    <strong>Durée moyenne : 45 min à 1h00</strong>
                  </div>
                </li>
              </ul>
            </div>
          </section>

          {/* Critères de validation */}
          <section className="cahier-section highlight-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.check}</span>
              <h2>Critères de validation d'un rendez-vous qualifié</h2>
            </div>
            <div className="section-content">
              <p className="section-intro">Un rendez-vous est considéré comme <strong>valide</strong> si :</p>
              <div className="validation-grid">
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Le gérant ou décisionnaire était bien présent</span>
                </div>
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Le rendez-vous a eu lieu sur le lieu de travail du prospect</span>
                </div>
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Le contact avait bien compris l'offre gratuite</span>
                </div>
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Il était informé des éventuels petits frais (nom de domaine, maintenance, etc.)</span>
                </div>
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Il a manifesté un réel intérêt pour la solution</span>
                </div>
                <div className="validation-item valid">
                  <span className="validation-icon-svg">{icons.check}</span>
                  <span>Il a fourni une réponse claire en fin de visite</span>
                </div>
              </div>
            </div>
          </section>

          {/* Suivi et reporting */}
          <section className="cahier-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.tool}</span>
              <h2>Suivi et reporting</h2>
            </div>
            <div className="section-content">
              <p className="section-intro">Chaque téléprospecteur doit noter dans le CRM ou le tableau de suivi :</p>
              <div className="reporting-table">
                <div className="reporting-row">
                  <span className="reporting-label">Identité</span>
                  <span className="reporting-value">Nom / société / fonction</span>
                </div>
                <div className="reporting-row">
                  <span className="reporting-label">Lieu</span>
                  <span className="reporting-value">Adresse exacte du rendez-vous</span>
                </div>
                <div className="reporting-row">
                  <span className="reporting-label">Planning</span>
                  <span className="reporting-value">Date et heure fixées</span>
                </div>
                <div className="reporting-row">
                  <span className="reporting-label">Confirmation</span>
                  <span className="reporting-value">Confirmation de présence du gérant</span>
                </div>
                <div className="reporting-row">
                  <span className="reporting-label">Statut</span>
                  <span className="reporting-value">Effectué / Annulé / Absent / Accepté / Refusé</span>
                </div>
                <div className="reporting-row">
                  <span className="reporting-label">Notes</span>
                  <span className="reporting-value">Secteur, intérêt, frais éventuels, remarques</span>
                </div>
              </div>
            </div>
          </section>

          {/* Indicateurs de qualité */}
          <section className="cahier-section kpi-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.settings}</span>
              <h2>Indicateurs de qualité</h2>
            </div>
            <div className="section-content">
              <div className="kpi-grid">
                <div className="kpi-card">
                  <div className="kpi-icon-svg">{icons.chart}</div>
                  <div className="kpi-value">80%</div>
                  <div className="kpi-label">Présence effective</div>
                  <div className="kpi-desc">minimum des rendez-vous doivent être honorés</div>
                </div>
                <div className="kpi-card">
                  <div className="kpi-icon-svg">{icons.target}</div>
                  <div className="kpi-value">100%</div>
                  <div className="kpi-label">Ciblage</div>
                  <div className="kpi-desc">des rendez-vous doivent concerner un gérant ou décisionnaire</div>
                </div>
                <div className="kpi-card">
                  <div className="kpi-icon-svg">{icons.award}</div>
                  <div className="kpi-value">1/4</div>
                  <div className="kpi-label">Conversion</div>
                  <div className="kpi-desc">au moins 1 entreprise vitrine validée pour 4 rendez-vous</div>
                </div>
              </div>
            </div>
          </section>

          {/* Rémunération */}
          <section className="cahier-section remuneration-section">
            <div className="section-header">
              <span className="section-icon-svg">{icons.award}</span>
              <h2>Votre Rémunération</h2>
            </div>
            <div className="section-content remuneration-content">
              <div className="remuneration-highlight">
                <div className="remuneration-badge">Commission par signature validée</div>
                <div className="remuneration-amount">
                  <span className="amount-range">150 € — 500 €</span>
                  <span className="amount-label">par contrat signé</span>
                </div>
                <p className="remuneration-detail">
                  Le montant de votre commission dépend <strong>des produits et services sélectionnés</strong> par le client lors de la signature.
                </p>

                <div className="agent-average">
                  En moyenne, <strong>1 agent fait 1 à 3 signatures par jour</strong>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Contact & Inscription */}
        <section className="cahier-section contact-section">
          <div className="section-header">
            <span className="section-icon-svg">{icons.send}</span>
            <h2>Rejoignez-nous</h2>
          </div>
          <div className="section-content">
            <div className="contact-grid">
              <div className="contact-form-wrapper">
                <h3>Inscription</h3>
                {formSent ? (
                  <div className="form-success">
                    <span className="success-check">{icons.check}</span>
                    <p>Merci ! Nous vous recontacterons rapidement.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="contact-form">
                    {error && <div className="form-error">{error}</div>}
                    <input
                      type="text"
                      name="nom"
                      placeholder="Votre nom"
                      value={formData.nom}
                      onChange={handleInputChange}
                      required
                      disabled={sending}
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="Votre email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      disabled={sending}
                    />
                    <input
                      type="tel"
                      name="telephone"
                      placeholder="Votre téléphone"
                      value={formData.telephone}
                      onChange={handleInputChange}
                      required
                      disabled={sending}
                    />
                    <textarea
                      name="message"
                      placeholder="Votre message (optionnel)"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows="3"
                      disabled={sending}
                    />
                    <button type="submit" className="btn-submit" disabled={sending}>
                      {sending ? 'Envoi en cours...' : 'Envoyer ma candidature'}
                    </button>
                  </form>
                )}
              </div>

              <div className="contact-info-wrapper">
                <h3>Contact direct</h3>
                <p className="contact-text">Une question ? Contactez-nous directement :</p>
                <div className="contact-buttons">
                  <a
                    href="https://wa.me/33743678501"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-btn"
                  >
                    <span className="whatsapp-icon">{icons.whatsapp}</span>
                    <span>WhatsApp</span>
                  </a>
                  <a
                    href="tel:+33743678501"
                    className="phone-btn"
                  >
                    <span className="phone-icon">{icons.phone}</span>
                    <span>Appeler</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="cahier-footer">
          <div className="footer-logo">E-Shop Pro</div>
          <p>Document officiel — {currentDate}</p>
          <p className="footer-tagline">Votre partenaire digital de confiance</p>
        </div>
      </div>
    </div>
  );
}

export default CahierDesChargesPublic;
